import { ReactNode, useRef } from "react";
import {
  DatePicker,
  FormInstance,
  InputNumber,
  ModalProps,
  Typography,
} from "antd";
import { useTranslation } from "react-i18next";
import SModalForm from "@/styles/SModalForm";
import { SaleReportHisItem, SaleReportHisItemAdd } from "@/types/sales";

interface DataFormProps extends ModalProps {
  handleCancel: () => void;
  handleOk: (data: SaleReportHisItemAdd) => Promise<void>;
  data: SaleReportHisItem | null;
  leftTitle: ReactNode;
  confirmLoading: boolean;
}

const { Title } = Typography;

const DataForm = (props: DataFormProps) => {
  const { t } = useTranslation();
  const formRef = useRef<FormInstance<SaleReportHisItemAdd>>(null);

  const FormInputNumber = <InputNumber changeOnWheel style={{ width: '100%' }} min={0} precision={0} />;

  return (
    <SModalForm<SaleReportHisItemAdd>
      width={600}
      modelFormRef={formRef}
      formItems={[
        !props.data ? {
          label: t("sale.time"),
          name: "date",
          children: <DatePicker style={{ width: '100%' }} readOnly={!!props.data} />,
          required: true,
          rules: [{ required: true, message: t("components.plProduct") }],
        } : {
          children: <Title level={4}>{props.data.date}</Title>
        },
        {
          label: 'SMT',
          name: "t1",
          children: FormInputNumber,
        },
        {
          label: 'DIP',
          name: "t2",
          children: FormInputNumber,
        },
        {
          label: 'TEST1',
          name: "t3",
          children: FormInputNumber,
        },
        {
          label: 'ASSY',
          name: "t4",
          children: FormInputNumber,
        },
        {
          label: 'TEST2',
          name: "t5",
          children: FormInputNumber,
        },
        {
          label: 'PACK',
          name: "t6",
          children: FormInputNumber,
        },
        {
          label: t("sale.inStock"),
          name: "t7",
          children: FormInputNumber,
        },
        {
          label: t("sale.outPro"),
          name: "t8",
          children: FormInputNumber,
        },
      ]}
      {...props}
    />
  );
};

export default DataForm;
